import React from 'react';

const Sell = () => {
    return(
       <div className="button">Buy</div>
    );
}

export default Sell;